import { OnboardingFormModuleName, OnboardingFormSectionName } from "../modules/onboarding/types";
import { getViewPort, getBreakpoint } from "../utils/common-utils";

export const NOT_FOUND_ERROR_PAGE_PATH = "/error/not-found";

export const FileType = {
  PDF: "pdf",
  VIDEO: ["mp4", "avi", "wmv"],
  IMG: [
    "bmp",
    "jpg",
    "jpeg",
    "png",
    "tif",
    "gif",
    "pcx",
    "tga",
    "exif",
    "fpx",
    "svg",
    "psd",
    "cdr",
    "pcd",
    "dxf",
    "ufo",
    "eps",
    "ai",
    "raw",
    "WMF",
    "webp",
  ],
};

// Events
export const EVENT_OPEN_LINK_WITHIN_PAGE = "PUBLIC_PORTAL_WEB: openLink";

export const onboardingExcludedMenuModules = [
  OnboardingFormModuleName.PreQuestions,
  OnboardingFormModuleName.TermsNConditions,
  OnboardingFormModuleName.ESignature,
];
export const onboardingPreModules = [OnboardingFormModuleName.PreQuestions];
export const onboardingPostModules = [
  OnboardingFormModuleName.TermsNConditions,
  OnboardingFormModuleName.BusinessFocus,
  OnboardingFormModuleName.ReinstatementModule,
  OnboardingFormModuleName.ESignature,
];
export const onboardingFocusBusinesstModules = [
  OnboardingFormModuleName.BusinessFocus,
  // OnboardingFormModuleName.ReinstatementModule,
];

export const isPhone =
  getViewPort().width < getBreakpoint("lg") && navigator.userAgent.match(/iPad/i) === null;

export enum NameCompositionEnum {
  firstName = "firstName",
  lastName = "lastName",
}
